import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { AuthService } from '../Services/auth.service';
import { AuthResponse, LaravelDefaultResponse } from '../Interfaces/response.interface';
import { User } from '../Models/user.model';

@Injectable({
  providedIn: 'root',
})
export class AuthFacade {
  private readonly _auth = inject(AuthService);

  readonly currentUser = toSignal<User | null, User | null>(this._auth.currentUser$, {
    initialValue: null,
  });
  readonly isAuthenticated = toSignal<boolean, boolean>(this._auth.isAuthenticated$, {
    initialValue: false,
  });

  initializeAuth(): Observable<boolean> {
    return this._auth.initializeAuth();
  }

  exchangeCode(
    code: string,
    handoffVerifier: string | null,
  ): Observable<LaravelDefaultResponse<AuthResponse>> {
    return this._auth.exchangeCode(code, handoffVerifier);
  }

  loadCurrentUser(): Observable<User> {
    return this._auth.me();
  }

  getAndClearReturnUrl(): string {
    return this._auth.getAndClearReturnUrl();
  }

  setReturnUrl(returnUrl: string): void {
    this._auth.setReturnUrl(returnUrl);
  }

  clearAuth(): void {
    this._auth.clearAuth();
  }

  logout(): void {
    this._auth.logout();
  }

  terminateSession(): Observable<boolean> {
    return this._auth.terminateSession();
  }
}
